export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-events-bc9439761ba65d0237ad56f2a0ab2804.svg";